import {replaceStringWithPattern} from '@dazn/lp-web/src/utils/replaceStringWithPattern';

const dictionary = window.dazn.resourceStringsData.Strings || {};

const defaultValue = '';

const genericMapGetter =
    (genericMap: any, replaceStringWithPattern: any) =>
    (mapKey: string, keyMappings?: any) => {
        if (!mapKey || mapKey === '' || !genericMap) {
            return defaultValue;
        }

        const value = genericMap[mapKey] || defaultValue;

        if (!keyMappings) {
            return value;
        }

        return replaceStringWithPattern(keyMappings, value);
    };

/**
 * Get Dictionary String
 *
 * Once the Dictionary is given, we can call directly to obtain a string.
 * The first parameter is the key, the second parameter is an object of values.
 *
 * Examples:
 *
 * const myString = getResourceString('myKey');
 * const myString = getResourceString('myKey', { toReplace: 'value' });
 *
 * @param {string} key - Key to look for
 * @param {object} mappings - Object with strings to look for and values to replace with
 * ... any number of parameters is supported
 *
 * @returns {string}
 */
const getDictionaryString = genericMapGetter(
    dictionary,
    replaceStringWithPattern
);

export {getDictionaryString, genericMapGetter};
